import React from 'react'
import styles from "./Styles/QuizHeader.module.css"
import navLogo from "../Assets/navLogo.png"
import { FaTimes } from 'react-icons/fa'
import { FiChevronRight } from 'react-icons/fi'
import { useLocation, useNavigate } from 'react-router-dom'

export default function QuizHeader(props) {

  const location = useLocation()
  const navigate = useNavigate()

  return (
    <div>
        <div className={styles.topLogo}>
            <div></div>
            <img src={navLogo} />
            <div onClick={()=>navigate('/dashboard')} className={styles.closeIcon}>
                <FaTimes color="#D6D6D6" size={32} />
            </div>
        </div>
        <div className={styles.steps}>

            <p className={(props.step1 || props.step2 || props.step3 || props.step4 || props.step5 || props.step6) && styles.activeStep}>Basic Details</p>
            <FiChevronRight color={(props.step2 || props.step3 || props.step4 || props.step5 || props.step6) ? '#161C45' : "#B2B2B2"} size={40} />

            <p className={(props.step2 || props.step3 || props.step4 || props.step5 || props.step6) && styles.activeStep}>Project Details</p>
            <FiChevronRight color={(props.step3 || props.step4 || props.step5 || props.step6) ? '#161C45' : "#B2B2B2"} size={40} />

            <p className={(props.step3 || props.step4 || props.step5 || props.step6) && styles.activeStep}>Design Your Style</p>
            <FiChevronRight color={(props.step4 || props.step5 || props.step6) ? '#161C45' : "#B2B2B2"} size={40} />

            <p className={(props.step4 || props.step5 || props.step6) && styles.activeStep}>Space Configuration</p>
            <FiChevronRight color={(props.step5 || props.step6) ? '#161C45' : "#B2B2B2"} size={40} />

            <p className={(props.step5 || props.step6) && styles.activeStep}>Cost Package</p>
            <FiChevronRight color={(props.step6) ? '#161C45' : "#B2B2B2"} size={40} />

            <p className={props.step6 && styles.activeStep}>Upload Layout</p>
        </div>
    </div>
  )
}
